export const SET_ITEM_ID = "SET_ITEM_ID";
export const SET_APPLICATION_TYPE = "SET_APPLICATION_TYPE";

export default {
  SET_ITEM_ID,
  SET_APPLICATION_TYPE,
};
